import React from "react";
import {Tag} from "antd";
import {FlagOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {TICKET_PRIORITY_COLORS} from "constants/ticket";

export const TicketPriorityTag = ({priority, pill}) => {
    const {t} = useTranslation(["tickets"]);

    return (
        <Tag
            color={TICKET_PRIORITY_COLORS[priority]}
            icon={pill ? <FlagOutlined /> : undefined}
            style={pill ? {borderRadius: 12, padding: "2px 10px"} : undefined}
        >
            {t(`priorities.${priority}`, {ns: "tickets"})}
        </Tag>
    );
};
